import React from "react";

//mui
import { styled } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/MenuItem";
import Autocomplete from "@mui/material/Autocomplete";
import InputAdornment from '@mui/material/InputAdornment';

//components
import CustomPopper from "./PopperComponent";

const Container = styled("div")(({ theme }) => ({
  "& .MuiMenuItem-root": {
    // background: "green",
  },
  "& .MuiAutocomplete-root": {
    background: "#F5F5F5",
  },
  "& .MuiAutocomplete-input": {
    height: "19px",
    fontSize: "14px",
    [theme.breakpoints.down("xl")]: {
      height: "17px",
      fontSize: "14px",
    },
  },
  "& .MuiInputLabel-root": {
    fontSize: "15px",
    color: "#4F4F4F",
    [theme.breakpoints.down("xl")]: {
      fontSize: "14px",
    },
  },
}));

const AutoCompleteStatusSelect = ({
  value,
  options,
  variant = "outlined",
  disabled = false,
  onChange,
  label,
  text,
  leftIcon,
  ...restProps
}) => {
  if(value?.name) {
    value.status = value.name;
    delete value.name;
  }
  const Icon = leftIcon;
  return (
    <Container>
      <FormControl variant="outlined" style={{ width: "100%", padding: 0 }}>
        <Autocomplete
          fullWidth
          value={value}
          options={options}
          isOptionEqualToValue={(option, value) => option.status === value.status}
          getOptionLabel={(option) => (option ? option.status : "")}
          onChange={(event, newValue) => onChange(newValue, text)}
          filterSelectedOptions
          renderInput={(params, index) => {
            const { InputProps, inputProps, ...renderProps } = params;
            inputProps.disabled = disabled;
            InputProps.endAdornment = disabled ? (
              <></>
            ) : (
              InputProps.endAdornment
            );
            return (
              <TextField
                key={index}
                {...renderProps}
                InputProps={{
                  ...InputProps,
                  // disableUnderline: variant === "standard" ? true : false,
                  startAdornment: leftIcon ? (<InputAdornment position="start"><Icon />
                  </InputAdornment>) :
                  (<></>),
                }}
                inputProps={inputProps}
                label={label}
                // className={classes.input}
                variant={variant}
                {...restProps}
              />
            );
          }}
          // PopperComponent={CustomPopper}
          PopperComponent={disabled ? () => null : CustomPopper} // Disable custom popper when disabled
          open={!disabled && undefined} // Control the dropdown opening behavior
          onOpen={(event) => disabled && event.preventDefault()} // Prevent opening when disabled
          onClose={(event) => disabled && event.preventDefault()}
        />
      </FormControl>
    </Container>
  );
};

export default AutoCompleteStatusSelect;